import React, { Component } from "react";
import { HashRouter, Route } from "react-router-dom";
import { Provider } from "react-redux";
import favicon from "./statics/favicon.png";

import Home from "./pages/home";
import Login from "./pages/login";
import Collect from "./pages/collect";
import Admin from "./pages/admin";
import ImageSearch from "./pages/imageSearch";
import Detail from './pages/detail'
import store from "./store";
import { ServiceWorkerContext } from "./ServiceWorkerContext";
import { detectDevice } from "./utils";
import { forceReloadTo } from "./utils/hardNavigation";

export const navigateToHashRoute = (route) => {
    if (window.location.hash !== route) {
        window.location.hash = route;
    }
};

export const cleanupLegacyServiceWorkers = async () => {
    if (!("serviceWorker" in navigator)) {
        return;
    }

    try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
    } catch (error) {
        console.log("ServiceWorker cleanup failed: ", error);
    }

    if (!("caches" in window)) {
        return;
    }

    try {
        const cacheKeys = await window.caches.keys();
        await Promise.all(cacheKeys.map((cacheKey) => window.caches.delete(cacheKey)));
    } catch (error) {
        console.log("Cache cleanup failed: ", error);
    }
};

export class App extends Component {
    constructor(props) {
        super(props);
            this.state = {
            deferredPrompt: null,
        };
    }

    ensureFavicon() {
        let link = document.querySelector("link[rel='icon']");

        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "icon");
            document.head.appendChild(link);
        }

        link.setAttribute("type", "image/x-icon");
        link.setAttribute("href", favicon);
    }

    componentDidMount() {
        // [2026-04-17 修复] 清理 forceReloadTo 添加的 reload 参数，保持 URL 干净
        // forceReloadTo 会在 URL 中拼接 ?reload=timestamp 强制刷新，刷新后自动移除
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('reload')) {
            urlParams.delete('reload');
            const cleanPath = urlParams.toString()
                ? `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`
                : `${window.location.pathname}${window.location.hash}`;
            window.history.replaceState(null, '', cleanPath);
        }

        document.title = "LinkStone";
        this.ensureFavicon();

        window.addEventListener("beforeinstallprompt", (e) => {
            e.preventDefault(); // 阻止默认事件
            this.setState({ deferredPrompt: e });
        });

        cleanupLegacyServiceWorkers();

        // 添加全局事件监听器以阻止所有图片上的上下文菜单
        document.body.addEventListener('contextmenu', this.handleContextMenu);

        window.addEventListener("storage", this.handleStorageChange);

        this.handleResize()
        // 组件挂载时添加窗口大小变化的事件监听器
        window.addEventListener('resize', this.handleResize);
    }

    handleSetZoom(newScale) {
        // document.body.style.zoom = newScale
        document.body.style.transform = `scale(${newScale})`;
        document.body.style.width = `${100 / newScale}vw`;
        document.body.style.height = `${100 / newScale}vh`;
    }

    componentWillUnmount() {
        // 组件卸载时移除事件监听器
        document.body.removeEventListener("contextmenu", this.handleContextMenu);

        window.removeEventListener("storage", this.handleStorageChange);
        // 组件卸载时移除事件监听器以避免内存泄漏
        window.removeEventListener("resize", this.handleResize);
    }


    handleResize = () => {
        // 更新状态以反映新的窗口大小
        let width = window.innerWidth;
        let height = window.innerHeight;
        if (detectDevice() === "computer_enterprise_wechat") {
            if (width >= 1601 && height >= 907) {
                this.handleSetZoom(1);
            } else {
                this.handleSetZoom(0.6);
            }
        }
    }

    handleStorageChange = (event) => {
        if (event.key === "loginState") {
            if (event.newValue) {
                // 更新组件状态
                // const newUser = JSON.parse(event.newValue);
                // console.log('User logged in:', newUser);
                console.log("User logged in");
                forceReloadTo("#/home");
            } else {
                // 用户已登出
                console.log("User logged out");
                localStorage.removeItem("loginState");
                forceReloadTo("#/");
            }
        }
    }

    handleContextMenu = (event) => {
        // 如果事件目标是图片，则阻止默认的上下文菜单
        if (event.target.tagName.toLowerCase() === 'img' || event.target.className === 'msg_images_id_overlay') {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    render() {
        return (
            <Provider store={store}>
                <ServiceWorkerContext.Provider value={this.state.deferredPrompt}>
                    <HashRouter>
                        <Route path="/" exact component={Login}></Route>
                        <Route path="/home" exact component={Home}></Route>
                        <Route path="/collect" exact component={Collect}></Route>
                        <Route path="/admin" exact component={Admin}></Route>
                        <Route path="/image" exact component={ImageSearch}></Route>
                        <Route path="/detail/:id" exact component={Detail}></Route>
                    </HashRouter>
                </ServiceWorkerContext.Provider>
            </Provider>
        )
    }
}

export default App
